import { Controller } from "@hotwired/stimulus";

// Dynamically updates the WHN Ad example previews based on period selection and link type
export default class extends Controller {
  static targets = ["filenamePreview", "altTextPreview"];

  // Maps period keys to month abbreviations [start, end]
  static periodMonths = {
    jan_feb: ["Jan", "Feb"],
    mar_apr: ["Mar", "Apr"],
    may_jun: ["May", "Jun"],
    jul_aug: ["Jul", "Aug"],
    sep_oct: ["Sep", "Oct"],
    nov_dec: ["Nov", "Dec"],
  };

  connect() {
    this.updatePreviews();
  }

  updatePreviews() {
    const periodSelect = document.getElementById("wire_harness_news_ad_publication_period");
    const yearSelect = document.getElementById("wire_harness_news_ad_publication_year");

    if (!periodSelect || !yearSelect) return;

    const period = periodSelect.value;
    const year = yearSelect.value;
    const months = this.constructor.periodMonths[period] || ["Jan", "Feb"];
    const productName = this.extractProductName();

    this.updateFilenamePreview(months[0], months[1], year);
    this.updateAltTextPreview(months[0], months[1], year, productName);
  }

  extractProductName() {
    // Check which link type radio is selected
    const productLineRadio = document.getElementById("link_type_product_line");
    const categoryRadio = document.getElementById("link_type_category");
    const staticPageRadio = document.getElementById("link_type_static_page");

    if (productLineRadio?.checked) {
      return this.extractFromSelect("wire_harness_news_ad_product_line_id");
    } else if (categoryRadio?.checked) {
      return this.extractFromSelect("wire_harness_news_ad_techflex_category_id");
    } else if (staticPageRadio?.checked) {
      return this.extractFromSelect("wire_harness_news_ad_static_page_key");
    }

    return "Techflex";
  }

  extractFromSelect(selectId) {
    const select = document.getElementById(selectId);
    if (!select || !select.value) return "Techflex";

    // Get the selected option's text content
    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption || !selectedOption.text) return "Techflex";

    // Clean up the text (remove leading dashes from optgroups, trim whitespace)
    const text = selectedOption.text.replace(/^[\s—-]+/, "").trim();
    return text || "Techflex";
  }

  updateFilenamePreview(startMonth, endMonth, year) {
    if (!this.hasFilenamePreviewTarget) return;

    this.filenamePreviewTarget.textContent = `techflex-${startMonth.toLowerCase()}-${endMonth.toLowerCase()}-${year}.jpg`;
  }

  updateAltTextPreview(startMonth, endMonth, year, productName) {
    if (!this.hasAltTextPreviewTarget) return;

    this.altTextPreviewTarget.textContent = `WHN Ad ${startMonth}-${endMonth} ${year} - ${productName}`;
  }
}
